import { useEffect, useState } from "react";
import { FlipHorizontal2 } from "lucide-react";
import { api } from "@/lib/api";

const OTHER = { right: "left", left: "right" };

function usePhoto(ill) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!ill?.storage) { setUrl(null); return undefined; }
    let u;
    api.get(`/illustrations/${ill.id}/image`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setUrl(null));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [ill?.id, ill?.storage]);
  return url || ill?.image_data || null;
}

export function Figure({ ill, svg: svgOverride, className = "h-20 w-20", testid, showFlip = true }) {
  const [flipped, setFlipped] = useState(false);
  const [flipSvg, setFlipSvg] = useState(null);
  const photo = usePhoto(ill);
  const base = svgOverride ?? ill?.svg;
  useEffect(() => { setFlipped(false); }, [ill?.id]);
  useEffect(() => { setFlipSvg(null); }, [base]);
  useEffect(() => {
    if (flipped && ill?.pose_params && !flipSvg) {
      api.post("/pose/render", { ...ill.pose_params, flip: true }).then((r) => setFlipSvg(r.data.svg));
    }
  }, [flipped, ill?.pose_params, flipSvg]);
  if (!ill) return null;
  const side = flipped ? OTHER[ill.laterality] || ill.laterality : ill.laterality;
  const svg = flipped && ill.pose_params ? flipSvg : base;
  return (
    <div className="relative" data-testid={testid}>
      {svg ? <div className={`${className} [&>svg]:h-full [&>svg]:w-full ${flipped && !ill.pose_params ? "-scale-x-100" : ""}`} dangerouslySetInnerHTML={{ __html: svg }} />
        : photo ? <img src={photo} alt={ill.alt_text || ill.title} className={`${className} object-cover rounded transition-transform ${flipped ? "-scale-x-100" : ""}`} />
          : <div className={`${className} grid place-items-center text-[10px] text-slate-400`}>image</div>}
      {showFlip && (
        <span role="button" tabIndex={0} data-testid={`${testid}-flip`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setFlipped((f) => !f); }}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setFlipped((f) => !f); } }} title="Flip left/right"
          className={`no-print absolute left-0.5 top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded px-1 py-0.5 text-[9px] font-semibold shadow-sm transition-colors ${flipped ? "bg-sky-600 text-white" : "bg-white/90 text-slate-600 hover:bg-sky-50"}`}>
          <FlipHorizontal2 size={10} />{side ? side[0].toUpperCase() : ""}
        </span>
      )}
    </div>
  );
}
